export type CatchHandler = (error: Error) => void | never;

// tslint:disable-next-line:ban-types there is no generic call signature for class which extend `Error`
export function generateCatchHandler(ignoreClasses: Array<Function>): CatchHandler {
    for (const type of ignoreClasses) {
        if (!(type.prototype instanceof Error) && type.prototype !== Error.prototype) {
            throw new Error('Invalid argument: expected class derived from `Error`');
        }
    }

    return (error: Error): void | never => {
        for (const type of ignoreClasses) {
            if (error instanceof type)  {
                return;
            }
        }

        throw error;
    };
}

export const ignoreAllRejects: CatchHandler = generateCatchHandler([Error]);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/submodules/utils/Error.ts